/*
 * Copyright (c) 2023 Pegasystems Inc.
 * All rights reserved.
 */
import Utils from '../../../utils/utils';

class DeletePage {
  static execute(target: string, pageReference: string) {
    return {
      target: Utils.buildInstructionPageReference(pageReference, target),
      instruction: 'DELETE'
    };
  }
}

export default DeletePage;
